import { render, staticRenderFns } from "./InfoBoxPanel.vue?vue&type=template&id=6231a264&scoped=true"
import script from "./InfoBoxPanel.vue?vue&type=script&lang=js"
export * from "./InfoBoxPanel.vue?vue&type=script&lang=js"
import style0 from "./InfoBoxPanel.vue?vue&type=style&index=0&id=6231a264&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6231a264",
  null
  
)

export default component.exports